const whatsappFields = new Set([
  "whatsappEnabled",
  "whatsappBusinessName",
  "whatsappNumber",
]);
export function clinicSettingsPayload(data, can) {
  return Object.fromEntries(
    Object.entries(data).filter(([key]) =>
      can("settings", whatsappFields.has(key) ? "whatsappConfig" : "clinic"),
    ),
  );
}
